export default "__VITE_ASSET__BrcPbDw6__"